/**
 * AlertsNotification.jsx
 * Created by michaelbray on 2/13/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import * as alertLevels from '../../../helpers/alertLevelsHelper';
import AlertsByLevel from "./AlertsByLevel";

const propTypes = {
    alerts: PropTypes.array.isRequired,
    fetchAlerts: PropTypes.func.isRequired,
    locationParams: PropTypes.shape({
        location_id: PropTypes.string,
        location_type: PropTypes.string
    })
};

const defaultProps = {
    alerts: [],
    fetchAlerts: () => true,
    locationParams: null
};

export default class AlertsNotification extends React.Component {
    componentDidMount() {
        this.props.fetchAlerts(this.props.locationParams);
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(this.props.locationParams, nextProps.locationParams)) {
            this.props.fetchAlerts(nextProps.locationParams);
        }
    }

    render() {
        if (!this.props.alerts || this.props.alerts.length === 0) {
            return null;
        }

        const infoAlerts = this.props.alerts.filter((a) => a.alert_level === alertLevels.INFO_ALERT_LEVEL);
        const warningAlerts = this.props.alerts.filter((a) => a.alert_level === alertLevels.WARNING_ALERT_LEVEL);
        const successAlerts = this.props.alerts.filter((a) => a.alert_level === alertLevels.SUCCESS_ALERT_LEVEL);
        const errorAlerts = this.props.alerts.filter((a) => a.alert_level === alertLevels.ERROR_ALERT_LEVEL);

        return (
            <div className="nav-header-alerts">
                <AlertsByLevel alerts={errorAlerts} level={alertLevels.ERROR_ALERT_LEVEL} />
                <AlertsByLevel alerts={warningAlerts} level={alertLevels.WARNING_ALERT_LEVEL} />
                <AlertsByLevel alerts={infoAlerts} level={alertLevels.INFO_ALERT_LEVEL} />
                <AlertsByLevel alerts={successAlerts} level={alertLevels.SUCCESS_ALERT_LEVEL} />
            </div>
        );
    }
}

AlertsNotification.propTypes = propTypes;
AlertsNotification.defaultProps = defaultProps;
